import { render, staticRenderFns } from "./AdDetails.vue?vue&type=template&id=c5037894&"
import script from "./AdDetails.vue?vue&type=script&lang=js&"
export * from "./AdDetails.vue?vue&type=script&lang=js&"
import style0 from "./AdDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports